import { render } from "./SelectPage.vue?vue&type=template&id=c7dec8aa"
import script from "./SelectPage.vue?vue&type=script&lang=js"
export * from "./SelectPage.vue?vue&type=script&lang=js"

import "./SelectPage.vue?vue&type=style&index=0&id=c7dec8aa&lang=css"
script.render = render

export default script